import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AmountTextService {
  private UNIDADES = [
    '',
    'uno ',
    'dos ',
    'tres ',
    'cuatro ',
    'cinco ',
    'seis ',
    'siete ',
    'ocho ',
    'nueve '
  ];
  private DECENAS = [
    'diez ',
    'once ',
    'doce ',
    'trece ',
    'catorce ',
    'quince ',
    'dieciseis ',
    'diecisiete ',
    'dieciocho ',
    'diecinueve ',
    'veinte ',
    'treinta ',
    'cuarenta ',
    'cincuenta ',
    'sesenta ',
    'setenta ',
    'ochenta ',
    'noventa '
  ];
  private CENTENAS = [
    '',
    'ciento ',
    'doscientos ',
    'trescientos ',
    'cuatrocientos ',
    'quinientos ',
    'seiscientos ',
    'setecientos ',
    'ochocientos ',
    'novecientos '
  ];

  constructor() {}

  letras(
    numero: number | string,
    moneda: string = 'Soles',
    uppercase: boolean = true
  ): string | null {
    let literal = '',
      parteDecimal;
    let isUpperCase = uppercase;

    numero = numero.toString().replace('.', ',');

    if (numero.indexOf(',') == -1) {
      numero += ',00';
    }

    if (numero.match('\\d{1,9},\\d{1,2}')) {
      const Num = numero.split(',');
      parteDecimal = `${Num[1]}/100 ${moneda}`;

      if (parseInt(Num[0]) === 0) {
        // si el valor es cero
        literal = 'cero ';
      } else if (parseInt(Num[0]) > 999999) {
        // si es millon
        literal = this.getMillones(Num[0]);
      } else if (parseInt(Num[0]) > 999) {
        // si es miles
        literal = this.getMiles(Num[0]);
      } else if (parseInt(Num[0]) > 99) {
        // si es centena
        literal = this.getCentenas(Num[0]);
      } else if (parseInt(Num[0]) > 9) {
        // si es decena
        literal = this.getDecenas(Num[0]);
      } else {
        // sino unidades -> 9
        literal = this.getUnidades(Num[0]);
      }

      return isUpperCase
        ? (literal + ' CON ' + parteDecimal).toUpperCase()
        : literal + ' con ' + parteDecimal;
    } else {
      return null;
    }
  }

  private getUnidades(numero: string): string {
    const num = numero.substring(numero.toString().length - 1);
    return this.UNIDADES[parseInt(num)];
  }

  private getDecenas(num: string): string {
    const n = parseInt(num);
    if (n < 10) {
      return this.getUnidades(num);
    } else if (n > 19) {
      const u = this.getUnidades(num);
      if (u === '') {
        return this.DECENAS[parseInt(num.substring(0, 1)) + 8];
      } else {
        return n > 20 && n < 30
          ? 'veinti' + u
          : this.DECENAS[parseInt(num.substring(0, 1)) + 8] + 'y ' + u;
      }
    } else {
      return this.DECENAS[n - 10];
    }
  }

  private getCentenas(num: string): string {
    if (parseInt(num) > 99) {
      return parseInt(num) === 100
        ? 'cien '
        : this.CENTENAS[parseInt(num.substring(0, 1))] +
            this.getDecenas(num.substring(1));
    } else {
      return this.getDecenas(parseInt(num).toString());
    }
  }

  private getMiles(numero: string): string {
    const c = numero.substring(numero.toString().length - 3);
    const m = numero.substring(0, numero.toString().length - 3);
    const n =
      parseInt(m) > 0
        ? (Number(m) > 1 ? this.getCentenas(m) : '') +
          'mil ' +
          this.getCentenas(c)
        : '' + this.getCentenas(c);
    return n;
  }

  private getMillones(numero: string): string {
    const miles = numero.substring(numero.toString().length - 6);
    const millon = numero.substring(0, numero.toString().length - 6);
    const n =
      millon.toString().length > 1
        ? this.getCentenas(millon) + 'millones '
        : this.getUnidades(millon) + 'millon ';
    return n + this.getMiles(miles);
  }

  getRound(num: number): number {
    return Math.round((num + Number.EPSILON) * 100) / 100;
  }
}
